export default __webpack_public_path__ + "media/images/borders/button-e372abb779bbd0b2485527d1f2bb69ee.svg";